.logo {
  width: 700px;
  height: 700px;
  border-radius: 1000px;
  background: conic-gradient(from 0deg, #027f52, #ecbfdf);
  animation: spinGradient 5s linear infinite;
}

@keyframes spinGradient {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(1800deg);
  }
}

.spinner {
  animation: spin 2s ease-in-out infinite;
  margin-top: inherit !important;
}

.titleContainer {
  /* width: 100%; */
  margin-left: 50px;
  margin-bottom: 16px;
}

.title {
  font-family: 'Inter', sans-serif;
  font-size: 22px;
  line-height: 30px;
  color: black;
  font-weight: 600;
}
